import roleApi from "../../api/rest/roleApi";

const getAllRole = async () => {
  const data = await roleApi.getAllRole();
  if (data) {
    return data;
  }
  return null;
}

const getRoleByDeptId = async (deptId) => {
  const roles = await roleApi.getRoleByDeptId(deptId);
  if (roles) {
    return roles;
  }
  return null;
};

export const roleBusiness = {
  getAllRole,
  getRoleByDeptId,
};